import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"
import { getImageUrl } from "./../utils";
// import { Skills } from './Skills';
export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const skills = [
    {
      title: "Python",
      imageSrc: "skills/python.png",
    },
    {
      title: "Django",
      imageSrc: "skills/django.png",
    },
    {
      title: "React Native",
      imageSrc: "skills/react.png",
    },
    {
      title: "HTML",
      imageSrc: "skills/html.png",
    },
    {
      title: "CSS",
      imageSrc: "skills/css.png",
    },
    {
      title: "JavaScript",
      imageSrc: "skills/JavaScript.png",
    },
    {
      title: "React",
      imageSrc: "skills/react.png",
    },

    {
      title: "PostgreSQL",
      imageSrc: "skills/PostgreSQL.png",
    },
    {
      title: "Figma",
      imageSrc: "skills/Figma.png",
    },
    {
      title: "Postman",
      imageSrc: "skills/Postman.png",
    },
  ];

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
                        <p> </p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            {/* <div className="item">
                                <img src={meter1} alt="Image" />
                                <h5>Web Development</h5>
                            </div>
                            <div className="item">
                                <img src={meter2} alt="Image" />
                                <h5>Brand Identity</h5>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="Image" />
                                <h5>Logo Design</h5>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="Image" />
                                <h5>Web Development</h5>
                            </div> */}

                            {skills.map((skill, id) => {
                            return (
                              <div key={id} className="item">
                                <img style={{height: 80}}
                                  src={require(`./../assets/${skill.imageSrc}`)}
                                  alt={skill.title}
                                />
                                <h5>{skill.title}</h5>
                              </div>
                            );
                          })}

                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}
